module.exports = __webpack_public_path__ + "static/media/mark.91e981f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CheckBox/images/mark.svg
// module id = 825
// module chunks = 0